import PropTypes from "prop-types";
import React, { useState } from "react";
import Heading from "../../elements/heading";
import Input from "../../elements/input";
import PrimaryButton from "../../elements/primary-button";
import BodyText from "../../elements/body-text";
import "./style.scss";
import { isBizNull } from "../../utils";
import { isValidEmail } from "../../utils/validations";

const InStoreLoginForm = ({
  formTitleType,
  formTitleBody,
  description,
  emailLabel,
  emailMissingMessage,
  emailNotExistMessage,
  emailWarningMessage,
  ctaName,
  colorScheme,
  iconName,
  ctaType,
  loginFailedMessage,
  loginWrongEmailOrPasswordMessage,
  loginNetworkErrorMessage,
  loginAccountLockMessage,
  loginFailed,
  loginNetworkError,
  loginWrongEmailOrPassword,
  loginAccountLock,
  inStoreMemberNotFound,
  onContinue,
  onEmailChanged
}) => {
  const [formDataEmail, setEmail] = useState();
  const [emailError, setEmailError] = useState(null);

  const onEmailFocus = evt => {
    setEmailError(null);
  };
  const onEmailChange = (evt, isValid) => {
    onEmailChanged && onEmailChanged(evt, isValid);
  };
  const onEmailBlur = (evt, valid) => {
    setEmail(evt.target.value);
    if (valid === false) {
      setEmailError(emailWarningMessage.value);
    } else {
      setEmailError(null);
    }
  };

  const validateForm = () => {
    let result = true;
    if (isBizNull(formDataEmail)) {
      result = false;
      setEmailError(emailMissingMessage.value);
    } else if (!isValidEmail(formDataEmail)) {
      result = false;
      setEmailError(emailWarningMessage.value);
    } else {
      setEmailError(null);
    }

    return result;
  };

  const onSubmit = evt => {
    const formData = { email: formDataEmail };
    if (validateForm()) {
      onContinue(evt, formData);
    }
  };
  return (
    <>
      <form className="login-form-in-store" autoComplete="on">
        {formTitleType && <Heading type={formTitleType} className="title show-on-scroll" html={formTitleBody} typographyClass={"type-h3"} />}
        {description && <BodyText html={description.value} className="description" />}
        {emailLabel && (
          <Input
            {...{
              autocomplete: "email",
              name: "email",
              label: emailLabel.value,
              warningMessage: emailError,
              type: "email",
              showError: emailError !== null,
              onFocus: evt => onEmailFocus(evt),
              onBlur: (evt, valid) => onEmailBlur(evt, valid),
              onChange: (evt, valid) => onEmailChange(evt, valid)
            }}
          />
        )}

        {loginFailed && loginFailedMessage && <span className="login-failed-message">{loginFailedMessage.value}</span>}
        {loginAccountLock && loginAccountLockMessage && <span className="login-failed-message">{loginAccountLockMessage.value}</span>}
        {loginNetworkError && loginNetworkErrorMessage && <span className="login-failed-message">{loginNetworkErrorMessage.value}</span>}
        {loginWrongEmailOrPassword && loginWrongEmailOrPasswordMessage && <span className="login-failed-message">{loginWrongEmailOrPasswordMessage.value}</span>}
        {inStoreMemberNotFound && emailNotExistMessage && <span className="login-failed-message">{emailNotExistMessage.value}</span>}

        <div className="button-container">
          {ctaName && (
            <PrimaryButton
              {...{
                colorScheme: colorScheme,
                iconName: iconName,
                link: {
                  value: {
                    text: ctaName.value
                  }
                },
                callback: evt => onSubmit(evt)
              }}
            />
          )}
        </div>
      </form>
    </>
  );
};

InStoreLoginForm.propTypes = {
  headingType: PropTypes.object,
  heading: PropTypes.object,
  emailLabel: PropTypes.shape({ value: PropTypes.string }),
  emailWarningMessage: PropTypes.shape({ value: PropTypes.string }),
  loginFailedMessage: PropTypes.shape({ value: PropTypes.string }),
  loginFailed: PropTypes.bool,
  ctaName: PropTypes.object,
  colorScheme: PropTypes.object,
  iconName: PropTypes.object,
  onContinue: PropTypes.func
};

InStoreLoginForm.defaultProps = {
  onContinue: () => {}
};

export default InStoreLoginForm;
